//-- Copyright (c) 2021 TMT Insights Group, LLC
import { Typography } from '@mui/material';
import { TitleEntity } from '@/redux/slices/slice_types';
import { getLineageMetaTitle } from '@/_utils/utils';
import { Thumbnail, TitleTypeLabel } from '@/exports/columnCommonComponents';

export default {
  thumbnail_link: {
    label: '',
    width: 50,
    isSortable: false,
    render: (cell: TitleEntity['thumbnail_link'], row: TitleEntity) => <Thumbnail src={cell} type={row.entity_type} />
  },
  external_id: {
    label: 'Title ID',
    width: 70,
    sortField: 'id',
    render: (cell: TitleEntity['external_id']) => (cell ? <strong style={{ color: 'var(--primary-main)' }}>{cell}</strong> : '-')
  },
  name: {
    label: 'Title',
    minWidth: 280,
    render: (cell: TitleEntity['name'], row: TitleEntity) => (
      <>
        <div>{cell}</div>
        <Typography variant="caption" sx={{ lineHeight: 1.9, fontSize: '.9rem' }}>
          {getLineageMetaTitle(row)}
        </Typography>
      </>
    )
  },
  entity_type: {
    label: 'Type',
    render: (cell: TitleEntity['entity_type']) => <TitleTypeLabel type={cell} />
  },
  rightsline_id: {
    label: 'Rightsline ID'
  },
  release_year: {
    label: 'Release Year'
  },
  brand: {
    label: 'Brand'
  },
  studio: {
    label: 'Studio'
  }
};
